import SiteList from '../views/Manage/SiteList';
import EditUser from '../views/Manage/EditUser';
import Census from '../views/Manage/Census';
import SiteCache from '../views/Manage/SiteCache';

let ManageData = [
  {
    path: 'SiteList',
    name: '站点列表',
    component: SiteList
  },
  {
    path: 'EditUser',
    name: '修改资料',
    component: EditUser
  },
  {
    path: 'Census',
    name: '数据统计',
    component: Census
  },
  {
    path: 'SiteCache',
    name: '首页缓存',
    component: SiteCache
  }
];
export default ManageData;
